import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { SidenavService } from '../services/sidenav.service';
import { UntypedFormGroup, FormsModule } from '@angular/forms';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { DatePipe, NgIf, NgFor } from '@angular/common';
import { SnackBarService } from '../../common/services/snack-bar/snack-bar.service';
import { TranslationService } from '../../common/services/languages/translation.service';
import { OrchestrationService } from '../services/orchestration-service/orchestration.service';
import { ApiResponseActions } from '../../store/api-response/api-response-actions';
import { select, NgRedux } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { ApiResponseState } from '../../store/api-response/api-response-state.model';
import { AppState } from '../../store/state.model';
import { environment } from '../../../environments/environment';
import { regex } from '../../common/regex.constants';
import { CmsTicketService } from './cms-ticket.service';
import { SelectedVehicleState } from '../../store/selected-vehicle-store/selected-vehicle-state.model';
import { MatFormField, MatSelect, MatOption, MatLabel } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-cms-ticket',
    templateUrl: './cms-ticket.component.html',
    styleUrls: ['./cms-ticket.component.scss'],
    imports: [FormsModule, NgIf, MatFormField, MatSelect, NgFor, MatOption, MatLabel, MatInput, MatButton, TranslatePipe]
})
export class CmsTicketComponent implements OnInit, OnDestroy {

  /**
   * @property used to store the file
   */
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  /**
   * @property used to store the pattern for email
   */
  public emailPattern: RegExp;
    /**
   * @property used to store the pattern for email
   */
    public datePattern: RegExp;
  /**
   * @property used to store the attachment status
   */
  public attachmentStatus: any;
  /**
   * @property used to store the drop over status
   */
  public isDropOver: boolean;
  /**
   * @property used to store the service desk id
   */
  serviceDeskId: any;
  /**
   * @property used to store the loading status
   */
  loadingFlag: boolean;
  /**
   * @property used to store the group list request
   */
  public requestGroupList: Record<string, string[]> = {
    'Account Management' : ['Account Phone Number Update', 'Account Login & Authentication', 'Account Creation', 'Account Email Update', 'Account Linking Issues', 'Account Deletion', 'Other Account Issues'],
    'Connected Services Support': ['Dealer Portal', 'Courtesy Service Extension (CSE) / Goodwill', 'Temporary DCM Activation', 'CTAdmin Portal', 'GR86 Portal'],
    'Digital Key': ['Other Digital Key Issues', 'Digital Key Removal (Key Revocation)', 'Digital Key Access', 'Digital Key Sharing / Guest Access', 'Digital Key Setup / Pairing', 'Digital Key Download / Installation'],
    'Drive Connect': ['Intelligent Assistant', 'Destination Assist', 'Cloud Navigation'],
    'Energy & Charging': ['HUBJECT', 'IONNA', 'Plug and Charge (PnC)', 'Charge Assist'],
    'Mobile App': ['Loan Payments', 'Apple Maps EV Routing', 'Performance Concerns / UI Issues', 'Phone Resource Consumption', 'Other App Issues', 'Integration Issues with the Backend', 'EV Credits'],
    'Multimedia Services': ['Radio | SXM', 'Android Auto', 'Spotify', 'Amazon Music (Integrated)', 'Apple Carplay'],
    'Platform Services Out of Car': ['Telemetry Data', 'EV', 'Legal Requests'],
    'Remote Connect': ['SmartWatch Sync', 'Last Parked Location', 'Remote Authorization', 'Guest Driver Monitor', 'Remote Commands', 'Remote Parking', 'Vehicle Status Alerts'],
    'Safety Connect': ['Remote Immobilizer', 'Roadside Assistance', 'Advanced Rear Seat Reminder (CDAS)', 'CT VLS', 'ACN', 'SOS', 'SVL'],
    'Service Connect': ['Maintenance Reminders', 'Vehicle Health Reports', 'Vehicle Maintenance Alerts'],
    'Service Shop': ['Service Shop Issues'],
    'Subscription Management': ['Ownership Transfer / Sold Event', 'Other Subscription Issues', 'Billing & Payment', 'Subscription Change / Update', 'Subscription Sync', 'Courtesy Service Extension / Goodwill', 'Subscription Enrollment', 'Offer Redemption'],
    'System Updates': ['Over-the-Air Firmware Updates', 'Software Download Portal'],
    'Vehicle Personalization': ['User Profile', 'Personalized Driver Settings'],
    'Vehicle Platform': ['Fleet Management', 'DCM Management', 'DCM Hardware', 'TC WAM', 'Head Unit', 'Connect Drive Recorder', 'Vehicle Data (CVS)'],
    'WiFi Connect': ['WiFi Signal Quality', 'Other WiFi Issues', 'WiFi Disabled', 'WiFi Connectivity', 'WiFi Enablement']
  }

    /**
   * @property used to store the group list
   */
    public selectedGroupList: string[] = [];

  /**
   * @property used to store the group list
   */
  public groupList: Array<any>;
  /**
   * @property used to store the fields list
   */
  public fieldsList = [
    { fieldId: 'case_type', name: 'Case Type', type: 'select', required: true, validValues: ['Account Support', 'Activation Failure', 'Billing Support', 'Connectivity Support', 'Device Support', 'Feedback/Compliant', 'General Inquiry', 'Subscription Support', 'Technical Support'] },
    { fieldId: 'short_description', name: 'Short Description', type: 'text', required: true },
    { fieldId: 'description', name: 'Description', type: 'textarea', required: false },
    { fieldId: 'impact', name: 'Impact', type: 'select', required: true, validValues: [{ label: 'Low', value: '3' },{ label: 'Medium', value: '2' },{ label: 'High', value: '1' }]},
    { fieldId: 'urgency', name: 'Urgency', type: 'select', required: true, validValues: [{ label: 'Low', value: '3' },{ label: 'Medium', value: '2' },{ label: 'High', value: '1' }]},
    { fieldId: 'customer_name', name: 'Customer Name', type: 'text', required: false },
    { fieldId: 'customer_email', name: 'Customer Email', type: 'email', required: false },
    { fieldId: 'brand', name: 'Brand', type: 'select', required: false, validValues: ['Toyota', 'Lexus', 'Subaru', 'Mazda'] },
    { fieldId: 'generation', name: 'Generation', type: 'select', required: false, validValues: ['17CY and Prior', '17CY+', '21MM', '24MM', 'GR86', '21MM Ops Trial', 'LMEX Ops Trial'] },
    // { fieldId: 'reporting_organization', name: 'Reporting Organization', type: 'select', required: true, validValues: ['CMS - de Mexico', 'CMS - Global Planning Team', 'CMS - Servco', 'CMS - TCI', 'CMS - TdPR'] },
    { fieldId: 'region', name: 'Region', type: 'select', required: false, validValues: ['US', 'Canada', 'Mexico', 'Hawaii', 'Puerto Rico'] },
    { fieldId: 'vin', name: 'VIN Number', type: 'text', required: false },
    { fieldId: 'vehicle_model', name: 'Vehicle Model', type: 'text', required: false },
    { fieldId: 'imei', name: 'IMEI', type: 'text', required: false },
    { fieldId: 'opened_by', name: 'Opened By', type: 'text', required: true },
    { fieldId: 'watch_list', name: 'Watch List', type: 'text', required: false },
    { fieldId: 'incident_occurred', name: 'Incident Occurred', type: 'text', required: true },
    { fieldId: 'additional_comments', name: 'Additional Comments', type: 'textarea', required: false }
  ];
  /**
   * @property used to store the jsd form
   */
  public jsdForm: UntypedFormGroup;
  /**
   * @property used to store the organization
   */
  public organization: any;
  /**
   * @property used to store the model of the form
   */
  public model: any;
  /**
   * @property used to store the alert
   */
  public alertMessage: any;
  /**
   * @property vehicle used to store the selected vehicle
   */
  public vehicle: any;
  /**
   * @property customer used to store the selected customer
   */
  public customer: any;
  /**
   * @property to store the api subscription
   */
  private apiSubscription;
  /**
  * @Property to observe the redux customer store
  **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;
  /**
  *@arg selectedVehicleObservable to observe selectedVehicle observable
  **/
  @select('selectedVehicle') readonly selectedVehicleObservable: Observable<SelectedVehicleState>;
  /**
  * @property to store the api subscription
  */
  private vehicleSubscription;
  /**
   * @property used to store the uploader
   */
  public uploader: FileUploader = new FileUploader({ url: '' });
  /**
   * @property used to store the uploader options
   */
  public uploaderOptions: any;
  public isApiError: boolean;
  constructor(
    private sidenav: SidenavService,
    public datepipe: DatePipe,
    private snackBarService: SnackBarService,
    private translate: TranslationService,
    private orch: OrchestrationService,
    public ngRedux: NgRedux<AppState>,
    private cmsTicketService: CmsTicketService
  ) {
    this.emailPattern = regex.emailPattern;
    this.datePattern = regex.datePattern;
    this.attachmentStatus = undefined;
    this.loadingFlag = false;
    this.model = {
      email: '',
      product: '',
      product_feature: '',
      short_description: '',
      description: '',
      case_type: '',
      impact: '',
      urgency: '',
      customer_name: '',
      customer_email: '',
      brand: '',
      generation: '',
      region: '',
      vin: '',
      vehicle_model: '',
      imei: '',
      watch_list: '',
      additional_comments: '',
      incident_occurred: '',
      // reporting_organization: '',
      opened_by: '',
      attachment: []
    };
    this.alertMessage = {
      type: '',
      msg: ''
    };
  }

  /**
   * @function ngOnInit sets initial configuration
   */
  ngOnInit() {
    this.vehicle = this.ngRedux.getState().selectedVehicle.vehicle;
    this.customer = this.ngRedux.getState().customer.data;
    this.model.customer_email = !!this.ngRedux.getState().auth.email ? this.ngRedux.getState().auth.email.toLowerCase() : '';
    this.isApiError = this.ngRedux.getState().admin.otherParams['trigger'] === 'error-dialog';

    this.vehicleSubscription = this.selectedVehicleObservable.subscribe(selectedVehicleState => {
      if (selectedVehicleState && selectedVehicleState.vehicle) {
        this.vehicle = selectedVehicleState.vehicle;
      }
    });

    this.apiSubscription = this.apiObservable.subscribe((api) => {
        this.fieldsList.forEach(field => {
          this.model[field.fieldId] = '';
        });

        for (const field of this.fieldsList) {
          switch (field.fieldId) {
            case 'region':
              if (this.vehicle.region) {
                this.model[field.fieldId] = this.getRegion(this.vehicle.region);
              }
              break;
            case 'brand':
              if (this.vehicle.brand) {
                this.model[field.fieldId] = this.getBrand(this.vehicle.brand);
              }
              break;
            case 'generation':
              if (this.vehicle.generation) {
                this.model[field.fieldId] = this.getGeneration(this.vehicle.generation);
              }
              break;
            case 'imei':
              this.model[field.fieldId] = this.vehicle.imei || this.vehicle['MEId'] || '';
              break;
            case 'vin':
              this.model[field.fieldId] = this.vehicle.vin || '';
              break;
            }
          }

        if (!this.model.impact) {
          this.model.impact = '3';
        }
        if (!this.model.urgency) {
          this.model.urgency = '3';
        }
        if (!this.model.reporting_organization) {
          this.model.reporting_organization = 'CMS - Global Planning Team'
        }
        if (!this.model.opened_by) {
          this.model.opened_by = this.ngRedux.getState().auth.email
        }

        const dateTime = new Date();
        this.model.incident_occurred = this.datepipe.transform(dateTime, 'yyyy-MM-dd hh:mm:ss');
        this.changeSubscriber();
      if (api.apiAction === ApiResponseActions.SET_CMS_CREATE_TICKET && api.cmsCreateTicketResponse['type'] === 'success') {
        const ticket = api.cmsCreateTicketResponse['result'][0]['display_value'];
        const message = this.translate.getCustomTranslation('create-cms-ticket.labels.ticket-created')['value'];
        this.snackBarService.showToast(`${ticket} ${message}`, undefined, 10);
        this.close();
        this.clearForm();
      }
      if (api.apiAction === ApiResponseActions.SET_CMS_CREATE_TICKET && api.cmsCreateTicketResponse['type'] === 'error') {
        const message = this.translate.getCustomTranslation('create-cms-ticket.labels.ticket-error')['value'];
        this.snackBarService.showToast(`${message}`, undefined, 10);
      }
    });
  }
  /**
  * @function close closes the side nav when called
  **/
  public close(): void {
    this.sidenav.close();
    this.clearForm()
  }
  /**
  * @function getGeneration returns the vehicle Generation name as per cms convention
  * @returns string
  **/
  public getGeneration(generation: string): string {
    switch (generation) {
      case '17CY':
      case 'PRE17CY':
        return '17CY and Prior';
      case '17CYPLUS':
        return '17CY+';
      case '21MM':
        return '21MM';
      case '24MM':
        return '24MM';
      case 'GR86':
        return 'GR86';
      case '21MM Ops Trial':
        return '21MM Ops Trial';
      case 'LMEX Ops Trial':
        return 'LMEX Ops Trial';
      default:
        return '';
    }
  }
  /**
  * @function getBrand returns the vehicle brnad name as per cms convention
  * @returns string
  **/
  public getBrand(brand: string): string {
    switch (brand) {
      case 'T':
        return 'Toyota';
      case 'L':
        return 'Lexus';
      case 'Subaru':
        return 'Subaru';
      case 'Mazda':
        return 'Mazda';
      default:
        return '';
    }
  }
  /**
  * @function getRegion returns the vehicle region name as per cms convention
  * @returns string
  **/
  public getRegion(region: string): string {
    switch (region) {
      case 'US':
        return 'US';
      case 'CA':
        return 'Canada';
      case 'MX':
        return 'Mexico';
      case 'HI':
        return 'Hawaii';
      case 'PR':
        return 'Puerto Rico';
      default:
        return '';
    }
  }
  /**
   * @function changeRequest fired when the request group is changed
   */
  changeRequest(e) {
    this.onClosed();
    const selectedRequestGroup = e.value;
    this.selectedGroupList = this.requestGroupList[selectedRequestGroup] || [];
    this.model.product = selectedRequestGroup;
    this.model.product_feature = '';
  }

  /**
   * @function changeGroup fired when the group is changed
   */
  changeGroup(e) {
    this.onClosed();
    const selectedGroup = e.value;
    this.model.product_feature = selectedGroup;
  }

  /**
   * @function onClosed resets the alert message on close sidenav
   */
  onClosed() {
    this.alertMessage = {
      type: '',
      msg: ''
    };
  }

    /**
   * @function requestGroupKeys gets keys from requestGroupList
   */
  requestGroupKeys(): string[] {
    return Object.keys(this.requestGroupList);
  }

  /**
   * @function ngOnDestroy Runs final sequence
   */
  ngOnDestroy() {
    if (this.apiSubscription) { this.apiSubscription.unsubscribe(); }
    if (this.vehicleSubscription) { this.vehicleSubscription.unsubscribe();}
  }

  /**
   * @function submitData Submits cms ticket
   */
  submitData(value: any) {
    this.onClosed();
    this.loadingFlag = true;
    let createRequest = {};
    if (value.valid) {
      createRequest = this.cmsTicketService.formatData(this.model, this.fieldsList, this.organization);
      const attachment = this.model['attachment'] ? this.model['attachment'] : '';
      this.orch.cmsCreateTicket(createRequest, attachment);
    } else {
      this.loadingFlag = false;
      this.alertMessage = {
        type: 'danger',
        msg: `Please enter the mandatory fields.`
      };
    }

  }

  /**
   * @function changeSubscriber adds the customer information to the form
   */
  changeSubscriber() {
    this.onClosed();
    this.model = this.cmsTicketService.onChangeSubscriber(this.model, this.fieldsList, this.vehicle, this.customer);
  }

  /**
   * @function changeDate - update the model with the selected date
   */
  changeDate(date, fieldId) {
    this.model[fieldId] = date.value;
  }

    /**
   * @function clearForm - resets the model to inital state once form is submitted / canceled
   */
  clearForm() {
    this.model = {
      email: '',
      product: '',
      product_feature: '',
      short_description: '',
      description: '',
      case_type: '',
      impact: '',
      urgency: '',
      customer_name: '',
      customer_email: '',
      brand: '',
      generation: '',
      region: '',
      vin: '',
      vehicle_model: '',
      imei: '',
      watch_list: '',
      additional_comments: '',
      // reporting_organization: '',
      incident_occurred: '',
      attachment: []
    };
  }

  /**
   * @function fileOverAnother fired if the file is dropped over the box
   */
  fileOverAnother(e: any): void {
    this.isDropOver = e;
  }

  /**
   * @function fileClicked fired if the file is clicked
   */
  fileClicked() {
    this.fileInput.nativeElement.click();
  }
}
